import { render } from "./WorkShiftChangeModal.vue?vue&type=template&id=4ec68b16"
import script from "./WorkShiftChangeModal.vue?vue&type=script&lang=js"
export * from "./WorkShiftChangeModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__